<!-- Page Content-->
<ng-container *ngIf="(isExternalGlxyPage$ | async) === false; else externalGlxyPage">
  <glxy-page [pagePadding]="false">
    <app-toolbar ngProjectAs="glxy-page-toolbar" />
    <glxy-page-wrapper [widthPreset]="FullWidth">
      <app-global-alerts />
      <ng-container *ngTemplateOutlet="pageContent" />
    </glxy-page-wrapper>
  </glxy-page>
</ng-container>

<!-- ensure that we only render one instance of router-outlet -->
<ng-template #pageContent>
  <router-outlet />
</ng-template>

<!-- routes that explicitly render their own glxy-page -->
<ng-template #externalGlxyPage>
  <div class="external-glxy-page">
    <ng-container *ngTemplateOutlet="pageContent" />
  </div>
</ng-template>
